import React from 'react';
import { DrawerItem, ItemData } from './drawer-item';

interface DrawerListProps {
  items: ItemData[];
  onItemPress: (route: string, label: string, actionType?: string) => void;
  onClose: () => void;
}

export const DrawerList: React.FC<DrawerListProps> = ({
  items,
  onItemPress,
  onClose,
}) => {
  return (
    <div className="side-drawer-list">
      {items.map((item, index) => (
        <DrawerItem
          key={index}
          {...item}
          onPress={onItemPress}
          onClose={onClose}
        />
      ))}
    </div>
  );
};
